export default "__VITE_ASSET__37841a11__"